import * as SVG from "@/svgs";
import { SvgProps } from "@/utils/types";

interface SvgSelectorProps extends SvgProps {
  name: keyof typeof SVG;
}

export const SvgSelector = ({
  name,
  primaryColor,
  className,
  secondaryColor,
  tertiaryColor,
  quaternaryColor,
  outlineColor,
}: SvgSelectorProps) => {
  const SvgComponent = SVG[name];
  return (
    <SvgComponent
      primaryColor={primaryColor}
      secondaryColor={secondaryColor}
      tertiaryColor={tertiaryColor}
      quaternaryColor={quaternaryColor}
      outlineColor={outlineColor}
      className={className}
    />
  );
};
